var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "#474747",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77637 11H10.7764V12H3.77637V11Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7764 8H3.77637V9H10.7764V8Z",
    fill: "#474747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.776367 0H9.17189L13.2244 4.50724V16H0.776367V0ZM11.8292 4.40869L9.30502 1.32779V4.40869H11.8292ZM12.2891 5.09852V15.0647H1.7117V0.935333H8.36968V5.09852H12.2891Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17637 0L13.2244 4.512L13.2244 16H0.776367V0H9.17637ZM8.37637 0.927999H1.72037V15.072H12.2964V5.104H8.37637V0.927999ZM10.7764 10.992L10.7764 12H3.78437V10.992H10.7764ZM10.7764 8L10.7764 8.992H3.78437V8H10.7764ZM9.30437 1.328V4.4H11.8324L9.30437 1.328Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentImg);
export default __webpack_public_path__ + "static/media/document-img.fbdde7f0005bfc2cde55c14d2d9f5f0b.svg";
export { ForwardRef as ReactComponent };